var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipmentRequestDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50241_23363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28125 1.5V2.5",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 11.5L5.28125 9.5L3.28125 7.5",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28125 9.5H5.28125",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 5.5V3.5C1.78125 3.23478 1.88661 2.98043 2.07414 2.79289C2.26168 2.60536 2.51603 2.5 2.78125 2.5H9.78125C10.0465 2.5 10.3008 2.60536 10.4884 2.79289C10.6759 2.98043 10.7812 3.23478 10.7812 3.5V10.5C10.7812 10.7652 10.6759 11.0196 10.4884 11.2071C10.3008 11.3946 10.0465 11.5 9.78125 11.5H7.5",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 5.5H10.7812",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28125 1.5V2.5",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50241_23363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.28125 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentRequestDate);
export default __webpack_public_path__ + "static/media/shipmentRequestDate.2c901ca0eda37a1cbcb506b76337609e.svg";
export { ForwardRef as ReactComponent };